import React, { Fragment, useState } from "react";
import { useEffect } from "react";
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from "react-redux";
import { getCustomerLastRequest, deleteService } from "../store/api/Services";
import { useHistory } from "react-router";
import ModalServiceEvents from "../Common/ModalServiceEvents";
import { Button } from "react-bootstrap";

// Random component
const LastRequest = () => {
    const [modalEvents, setModalEvents] = useState({ show: false });
    const autoSendStaff = localStorage.getItem("AutoSendStaff") === "true";
    let isLoadingSaved = useSelector(state => state.loading?.isLoading);
    const dispatch = useDispatch();
    let lastService = useSelector(state => state.service.lastService);
    const requestLastService = () => {
        let serviceType = localStorage.getItem("LastServiceType");
        let serviceID = localStorage.getItem("LastServiceID");
        if (serviceID && lastService?.ServiceID !== serviceID) {
            dispatch(getCustomerLastRequest(serviceType, serviceID));
        }
    }
    function showModalEvents(row) {
        setModalEvents({
            show: true,
            ServiceID: lastService.ServiceID,
            ServiceType: lastService.ServiceType
        })
    }
    useEffect(() => {
        requestLastService();
    }, [isLoadingSaved]);
    let now = Number(localStorage.getItem("now"));
    let then = Date.now();
    const history = useHistory();
    const deleteRequest = () => {
        let serviceType = localStorage.getItem("LastServiceType");
        let serviceID = localStorage.getItem("LastServiceID");
        dispatch(deleteService(serviceType, serviceID, () => {
            localStorage.removeItem("LastServiceID");
            localStorage.removeItem("LastServiceType");
            dispatch(getCustomerLastRequest(null, null));
            history.push("/");
        }))
    }
    return (
        //        
        <Fragment>

            {(isLoadingSaved || lastService === '' || lastService === "Pending") &&
                <Loader type="BallTriangle" color="#bb1370" height={50} width={50} />
            }
            {!isLoadingSaved && lastService && lastService !== '' && lastService !== "NotFound" && lastService !== 'Pending' &&
                <div className="container-fluid mt-2">
                    <ModalServiceEvents popData={modalEvents} setPopData={setModalEvents} />
                    <br />
                    <div className="card" style={{ backgroundColor: "rgb(232 217 223)", boxShadow: "2px 5px 10px black" }}>
                        <div className="card-header" style={{ backgroundColor: "rgb(162, 20, 72)", color: "white" }}>آخرین درخواست</div>
                        {then - now < 300000 && autoSendStaff &&
                            <div style={{ paddingTop: "5px", paddingRight: "2px" }}>
                                <span style={{
                                    color: "#0014ff", fontWeight: "bold", fontSize: "11.5px", float: "right",
                                    borderLeft: "none", padding: "5px", backgroundColor: "red", backgroundImage: "linear-gradient(to left, #fd5454, rgb(232, 217, 223))"
                                }}><Loader type="Puff" color="#0014ff" width={18} height={18} style={{ display: "inline-block" }} />&nbsp;در حال یافتن نزدیکترین تکنسین...‏</span>

                            </div>
                        }
                        <div className="card-body  row" style={{ textAlign: "justify" }}>
                            {lastService.StatusName === "sent" &&
                                <Fragment>
                                    <div className="col-5 mt-2">تکنسین اعزامی</div><div className="col-7 mt-2"> {lastService.StaffName} </div>
                                    <div className="col-5 mt-2"> شماره همراه </div><div className="col-7 mt-2"> {lastService.StaffMobile} </div>
                                    <div className="col-5 mt-2"> تاریخ اعزام </div><div className="col-7 mt-2"> {lastService.PSendDate} </div>
                                </Fragment>}
                            <div className="col-5 mt-2"> وضعیت درخواست </div><div className="col-7 mt-2"> {lastService.PStatusName} </div>
                            <div className="col-5 mt-2"> شماره درخواست </div><div className="col-7 mt-2"> {lastService.InvoiceNumber} </div>
                            <div className="col-5 mt-2"> تاریخ درخواست </div><div className="col-7 mt-2"> {lastService.PDate} </div>
                            <div className="col-5 mt-2"> نام محصول </div><div className="col-7 mt-2"> {lastService.ProductName} </div>
                            <div className="col-5 mt-2"> مدل محصول </div><div className="col-7 mt-2"> {lastService.ProductModel} </div>
                            <div className="col-5 mt-2"> نوع سرویس</div><div className="col-7 mt-2">  {lastService.PServiceType} </div>
                            <div className="col-5 mt-2">  شماره سریال</div><div className="col-7 mt-2"> {lastService.SerialNumber} </div>
                            <div className="mt-2">
                                <Button className="group-Btn-large" variant="info" onClick={showModalEvents}>رویدادها</Button>
                                {lastService.StatusName === "WaitingForReception" &&
                                    <Button variant="danger" className="group-Btn-large" onClick={deleteRequest}>لغو درخواست</Button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    )
}
export default LastRequest;